import { useState, useEffect } from 'react'

const getDeviceConfig = (width) => {
  if (width < 640) {
    return 'sm'
  } else if (width >= 640 && width < 720) {
    return 'md'
  } else if (width >= 720 && width < 1160) {
    return 'lg'
  } else if (width >= 1160 && width < 1348) {
    return 'xl'
  } else if (width >= 1348) {
    return '2xl'
  }
}

const isBrowser = typeof window !== 'undefined'

const useBreakpoint = () => {
  const [brkPnt, setBrkPnt] = useState(() =>
    isBrowser ? getDeviceConfig(window.innerWidth) : 'lg'
  )

  useEffect(() => {
    if (!isBrowser) {
      return
    }

    const calcInnerWidth = function () {
      setBrkPnt(getDeviceConfig(window.innerWidth))
    }
    window.addEventListener('resize', calcInnerWidth)

    return () => window.removeEventListener('resize', calcInnerWidth)
  }, [])

  return brkPnt
}

export default useBreakpoint
